module.exports = __webpack_public_path__ + "static/media/coatofarms.673471d9.svg";